import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getCompanyOffersItem } from '../../api'
import { GenericItemEntry } from '../../components'
import { NewsItem } from '../../interfaces'

export const CompanyOffersEntry = () => {
  const { id } = useParams()
  const { i18n } = useTranslation()

  const { data, isLoading } = useQuery<NewsItem>(
    ['company-offers-entry', id],
    () => getCompanyOffersItem(id as string, i18n.language),
    {
      enabled: !!id,
    }
  )

  return <GenericItemEntry isLoading={isLoading} data={data} />
}
